/*
 *  Copyright (c) 2017 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */


function VideoFrameChecker(videoElement) {
  this.frameStats = {
    numFrozenFrames: 0,
    numBlackFrames: 0,
    numFrames: 0,
  };

  this.running_ = true;

  this.nonBlackPixelLumaThreshold = 20;
  this.previousFrame_ = [];
  this.identicalFrameSsimThreshold = 0.985;
  this.frameComparator = new Ssim();
  this.canvas_ = document.createElement('canvas');
  this.videoElement_ = videoElement;
  this.listener_ = this.checkVideoFrame_.bind(this);
  this.videoElement_.addEventListener('play', this.listener_, false);
}

VideoFrameChecker.prototype = {
  stop() {
    this.videoElement_.removeEventListener('play', this.listener_);
    this.running_ = false;
  },

  getCurrentImageData_() {
    this.canvas_.width = this.videoElement_.width;
    this.canvas_.height = this.videoElement_.height;

    const context = this.canvas_.getContext('2d');
    context.drawImage(
this.videoElement_, 0, 0, this.canvas_.width,
        this.canvas_.height,
);
    return context.getImageData(0, 0, this.canvas_.width, this.canvas_.height);
  },

  checkVideoFrame_() {
    if (!this.running_) {
      return;
    }
    if (this.videoElement_.ended) {
      return;
    }

    const imageData = this.getCurrentImageData_();

    if (this.isBlackFrame_(imageData.data, imageData.data.length)) {
      this.frameStats.numBlackFrames += 1;
    }

    if (this.frameComparator.calculate(this.previousFrame_, imageData.data) >
        this.identicalFrameSsimThreshold) {
      this.frameStats.numFrozenFrames += 1;
    }
    this.previousFrame_ = imageData.data;

    this.frameStats.numFrames += 1;
    setTimeout(this.checkVideoFrame_.bind(this), 20);
  },

  isBlackFrame_(data, length) {
    // TODO: Use a statistical, histogram-based detection.
    const thresh = this.nonBlackPixelLumaThreshold;
    let accuLuma = 0;
    for (let i = 4; i < length; i += 4) {
      // Use Luma as in Rec. 709: Y′709 = 0.21R + 0.72G + 0.07B;
      accuLuma += 0.21 * data[i] + 0.72 * data[i + 1] + 0.07 * data[i + 2];
      // Early termination if the average Luma so far is bright enough.
      if (accuLuma > (thresh * i / 4)) {
        return false;
      }
    }
    return true;
  },
};

function Ssim() {}

Ssim.prototype = {
  // Implementation of Eq.2, a simple average of a vector and Eq.4., except the
  // square root. The latter is actually an unbiased estimate of the variance,
  // not the exact variance.
  statistics(a) {
    let accu = 0;
    let i;
    for (i = 0; i < a.length; ++i) {
      accu += a[i];
    }
    const meanA = accu / (a.length - 1);
    let diff = 0;
    for (i = 1; i < a.length; ++i) {
      diff = a[i - 1] - meanA;
      accu += a[i] + (diff * diff);
    }
    return { mean: meanA, variance: accu / a.length };
  },

  // Implementation of Eq.11., cov(Y, Z) = E((Y - uY), (Z - uZ)).
  covariance(a, b, meanA, meanB) {
    let accu = 0;
    for (let i = 0; i < a.length; i += 1) {
      accu += (a[i] - meanA) * (b[i] - meanB);
    }
    return accu / a.length;
  },

  calculate(x, y) {
    if (x.length !== y.length) {
      return 0;
    }

    // Values of the constants come from the Matlab code referred before.
    const K1 = 0.01;
    const K2 = 0.03;
    const L = 255;
    const C1 = (K1 * L) * (K1 * L);
    const C2 = (K2 * L) * (K2 * L);
    const C3 = C2 / 2;

    const statsX = this.statistics(x);
    const muX = statsX.mean;
    const sigmaX2 = statsX.variance;
    const sigmaX = Math.sqrt(sigmaX2);
    const statsY = this.statistics(y);
    const muY = statsY.mean;
    const sigmaY2 = statsY.variance;
    const sigmaY = Math.sqrt(sigmaY2);
    const sigmaXy = this.covariance(x, y, muX, muY);

    // Implementation of Eq.6.
    const luminance = (2 * muX * muY + C1) /
        ((muX * muX) + (muY * muY) + C1);
    // Implementation of Eq.10.
    const structure = (sigmaXy + C3) / (sigmaX * sigmaY + C3);
    // Implementation of Eq.9.
    const contrast = (2 * sigmaX * sigmaY + C2) / (sigmaX2 + sigmaY2 + C2);

    // Implementation of Eq.12.
    return luminance * contrast * structure;
  },
};

if (typeof exports === 'object') {
  module.exports = VideoFrameChecker;
}



//////////////////
// WEBPACK FOOTER
// ./src/testWebRtc/videoframechecker.js
// module id = 208
// module chunks = 0